import { Translations } from "@types";

export const updateTranslation: (previous: Translations, languageCode: string, newValue: string) => Translations = (
    previous, languageCode, newValue
) => {
    const translationItem = previous.find(
        (item) => item.languageCode === languageCode
    );

    if (translationItem) {
        return previous.map((item) => {
            return {
                ...item,
                translation: languageCode === item.languageCode ? newValue : item.translation,
            };
        });
    } else {
        return [
            ...previous,
            { languageCode: languageCode || '', translation: newValue},
        ];
    }
};